import { ReactComponent as FuelIcon } from "../../../assets/icons/gas.svg";
import { Separator } from "../../../components/ui/common";
import DashboardCard from "../../../components/ui/dashboard/DashboardCard";
import { formatCurrency, formatCurrencyForTable } from "../../../lib/utils";
import { Vehicle } from "../../vehicle/@types";

interface VehicleFuelCardProps {
  vehicle: Vehicle;
}

const VehicleFuelCard: React.FC<VehicleFuelCardProps> = ({ vehicle }) => {
  const cards = [
    {
      label: "Total fuel consumption",
      value: `${formatCurrencyForTable(vehicle.fuelConsumption)} lt`,
      index: 0,
      icon: <FuelIcon />,
    },
    {
      label: "Total fuel purchased",
      value: `${formatCurrency(vehicle.totalFuelPurchased)}`,
      index: 1,
      icon: <FuelIcon />,
    },
  ];

  return (
    <div className="flex flex-wrap gap-x-4 gap-y-4 sm:gap-x-10 sm:gap-y-6 bg-white rounded-[10px] p-4">
      {cards.map(({ label, value, index, icon }) => (
        <div key={index}>
          <DashboardCard
            key={index}
            icon={icon}
            value={value}
            label={label}
            className="w-[300px]"
          />

          {index < cards?.length - 1 && <Separator />}
        </div>
      ))}
    </div>
  );
};

export default VehicleFuelCard;
